import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../../services/auth.service";
import {ApiService} from "../../services/api.service";
import {ForgotUsernameService} from "./services/forgot-username.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-forgot-username',
  templateUrl: './forgot-username.component.html',
  styleUrls: ['./forgot-username.component.scss'],
  standalone: false
})
export class ForgotUsernameComponent implements OnInit {

  breadCrumbs = [
    { iconClass: 'bi-house', path: 'https://www.scalanthropy.com/'},
    { label: 'Home', path: 'https://www.scalanthropy.com/'},
    { label: 'Login', path: 'app/login'},
    { label: 'Forgot Username', path: 'app/login/forgot-username'}
  ];

  showMessages: boolean = false;
  messages: any[] = [];

  inputPhoneNumber: string = '';
  inputLastName: string = '';

  recoveredUsername: string = '';

  constructor(private authService: AuthService, private apiService: ApiService,
              private router: Router, private route: ActivatedRoute,
              private forgotUsernameService: ForgotUsernameService,
              private titleService: Title) {
    this.ngOnInit();
  }

  ngOnInit(): void {
    this.titleService.setTitle("Scalanthropy Forgot Username")
  }

  showMessagesToUser(): void {
    this.showMessages = true;
    const counterFn = () => {
      this.showMessages = false;
    }
    setTimeout(counterFn, 8000);
  }

  onSubmit(): any {
    //Obtain email
    this.messages = [];
    console.log('Validating Phone Number');
    const phoneNumberEl = document.getElementById('phone-number-text-id');
    // @ts-ignore
    this.inputPhoneNumber = phoneNumberEl.value;
    if (!this.inputPhoneNumber) {
      this.messages.push({
        field: 'Phone Number Error',
        detail: 'Phone Number: ' + this.inputPhoneNumber + ' is not valid.',
        severity: 'error'
      })
    }
    let modPhoneNumber: string = this.inputPhoneNumber.replaceAll("-", "");
    modPhoneNumber = modPhoneNumber.replaceAll(" ", "");
    modPhoneNumber = modPhoneNumber.replaceAll("(", "");
    modPhoneNumber = modPhoneNumber.replaceAll(")", "");
    if (modPhoneNumber && modPhoneNumber.length != 10) {
      this.messages.push({
        field: 'Phone Number',
        detail: 'Phone Number: ' + this.inputPhoneNumber + ' is not valid. The Phone Number must be exactly 10 digits and must be a US phone number.',
        severity: 'error'
      })
    }
    this.inputPhoneNumber = modPhoneNumber;

    const lastNameEl = document.getElementById('last-name-text-id');
    // @ts-ignore
    this.inputLastName = lastNameEl.value;
    if (!this.inputLastName) {
      this.messages.push({
        field: 'Last Name Name',
        detail: 'Last Name: ' + this.inputLastName + ' is not valid.',
        severity: 'error'
      })
    }

    if (this.messages.length > 0) {
      this.showMessagesToUser();
      return;
    }

    this.forgotUsernameService.forgotUsernameByPhoneNumberAndLastName(this.inputPhoneNumber, this.inputLastName).subscribe(
      (result: any) => {
        if (result && result.body) {
          // Display success message of sending email
          this.recoveredUsername = result.body.email;
        }
      },  (error: any) => {
        console.log('Forgot Username Email: ' + JSON.stringify(error));
        this.messages.push({
          field: 'Forgot Username Failure',
          detail: 'Your phone number or last name is not in the system! Check your spelling.',
          severity: 'error'
        })
        this.showMessagesToUser();
        return;
      });
  }

  /*
  onSubmit(): any {
    //Obtain email
    this.messages = [];
    console.log('Validating Email');
    const emailEl = document.getElementById('email-text-id');
    // @ts-ignore
    const email: string = emailEl.value;
    console.log('email: ' + email);
    if (!email) {
      console.log('email: ' + email + ' is not valid.');
      this.messages.push({
        field: 'Email',
        detail: 'Email: ' + email + ' is not valid.',
        severity: 'error'
      })
    }
    //contactChannel = EMAIL
    let phoneNumber: string = ''; //Phone numbers are not supported yet.
    let contactChannel: string = 'EMAIL';

    if (this.messages.length > 0) {
      this.showMessagesToUser();
      return;
    }

    this.forgotUsernameService.forgotUsernameEmail(email).subscribe(
      (result: any) => {
        if (result && result.body) {
          // Display success message of sending email

          // 3 second timeout before navigating back to the
          setTimeout(() => {this.router.navigateByUrl('/app/login');}, 3000)

        }
      },  (error: any) => {
        console.log('Forgot Username Email: ' + JSON.stringify(error));
        this.messages.push({
          field: 'Forgot Username Failure',
          detail: 'Failed to send Forgot Username Email!',
          severity: 'error'
        })
        this.showMessagesToUser();
        return;
      });
  }*/

  onCancel(): any {
    this.router.navigateByUrl('/app/login');
  }
}
